import { useCallback } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { api } from '@/services/api';

export function useAuth() {
  const { user, token, isAuthenticated, isLoading, error, setUser, logout, setLoading, setError, clearError } =
    useAuthStore();

  const login = useCallback(
    async (pin: string) => {
      setLoading(true);
      clearError();
      try {
        const data = await api.login(pin);
        setUser(data.user, data.token);
        return true;
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Login failed. Please try again.';
        setError(message);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [setUser, setLoading, setError, clearError]
  );

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout: handleLogout,
    clearError,
    isAdmin: user?.role === 'admin',
  };
}
